import React from "react";
import { bool, node } from "prop-types";

import * as S from "./styled";

const Dropdown = ({ children, ...props }) => (
  <S.Dropdown data-react-component {...props}>
    {children}
  </S.Dropdown>
);

Dropdown.propTypes = {
  children: node.isRequired,
  isActive: bool
};

Dropdown.defaultProps = {
  isActive: false
};

export default Dropdown;
